import { MenuItem, OverflowMenu, Text } from "@ui-kitten/components";
import Chevron from "components/Chevron";
import ProfileAvatar from "components/ProfileAvatar";
import Spacer from "components/Spacer";
import { Image } from "expo-image";
import { AccountMemberDetails } from "features/types";
import useCurrentUser from "hooks/useCurrentUser";
import { useFetchAccountBFFQuery } from "queries/account.queries";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import React, { useState } from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { svgURL } from "utils/fileUtils";
import { getUserName, initial } from "utils/userUtils";
import CustomerWallet from "./CustomerWallet";

const LOGO_SIZE = 70;
const Header = () => {
  const { data: branding } = useFetchTenantBrandingQuery();
  const { userImageURL } = useCurrentUser();
  const { data: accountBff } = useFetchAccountBFFQuery();
  const accountMembers = accountBff?.account.members;
  const [menuVisible, setMenuVisible] = useState(false);
  const [selectedMember, setSelectedMember] = useState<
    AccountMemberDetails | undefined
  >(accountMembers?.[0]);

  if (!branding) return null;

  const { name, primaryColor } = branding;

  return (
    <View style={[styles.headerContainer, { backgroundColor: primaryColor }]}>
      {selectedMember !== undefined && (
        <>
          <View style={styles.userDetailsContainer}>
            <View
              style={{ flexDirection: "row", alignItems: "center", flex: 1 }}
            >
              <View style={{ flex: 0.2 }}>
                <ProfileAvatar
                  hasImageIdentifier={!!selectedMember?.user.imageIdentifier}
                  source={{
                    uri: userImageURL,
                  }}
                  initial={initial(selectedMember?.user)}
                  size={48}
                />
              </View>
              <View style={{ flex: 0.7 }}>
                <Text style={{ fontSize: 14 }} appearance="hint">
                  Hello,
                </Text>
                <View className="flex-row items-center">
                  <Text status="control" style={{ fontSize: 18 }}>
                    {getUserName(selectedMember?.user)}
                  </Text>
                  {accountMembers && accountMembers?.length > 1 && (
                    <OverflowMenu
                      anchor={() => (
                        <Pressable onPress={() => setMenuVisible(true)}>
                          <Chevron direction="down" color="white" />
                        </Pressable>
                      )}
                      visible={menuVisible}
                      onBackdropPress={() => setMenuVisible(false)}
                    >
                      {accountMembers?.map((member) => (
                        <MenuItem
                          key={member.id}
                          title={getUserName(member.user)}
                          onPress={() => {
                            setSelectedMember(member);
                            setMenuVisible(false);
                          }}
                        />
                      ))}
                    </OverflowMenu>
                  )}
                </View>
              </View>
            </View>
            <View style={{ flex: 0.1 }}>
              <View style={styles.logo}>
                <Image
                  source={{ uri: svgURL(name) }}
                  style={{
                    width: LOGO_SIZE,
                    height: LOGO_SIZE,
                  }}
                  responsivePolicy="initial"
                  contentFit="contain"
                />
              </View>
            </View>
          </View>
          <Spacer />
          {selectedMember && <CustomerWallet member={selectedMember} />}
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    borderRadius: 12,
    padding: 14,
    paddingBottom: 0,
    overflow: "hidden",
    marginBottom: 14,
  },
  userGreetingContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  userDetailsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  logo: {
    position: "absolute",
    right: 0,
    top: -(LOGO_SIZE / 2),
  },
});
export default Header;
